// removed by extract-text-webpack-plugin
module.exports = {"PriceTag":"PriceTag__PriceTag__AHXyh","Price":"PriceTag__Price__1nn-P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/PriceTag/PriceTag.css
// module id = 142
// module chunks = 0